module.exports = __webpack_public_path__ + "img/renaissance_cleaning_services_12.29613570.jpg";